import React from 'react';
import { StyledTable, StyledTableContent, StyledTableHeader, StyledTableRow } from '../table/StyledTable';
import { useFormikContext } from 'formik';
import { ICheckDepositData } from 'types/order/escrow/ICheckDeposit';
import { IncomingDepositRow } from './IncomingDepositRow';

interface IIncomingCheckTableProps {
  onDelete: (id: string) => void;
  remove: (index: number) => void;
}
export const IncomingCheckTable: React.FC<IIncomingCheckTableProps> = ({ onDelete, remove }) => {
  const columns = ['Amount', 'Payer Type', 'Category'];
  const { values, initialValues, setFieldValue } = useFormikContext<{
    checkDeposits: ICheckDepositData[];
  }>();
  const { checkDeposits } = values;

  const onCancelEdit = (index: number) => {
    if (initialValues.checkDeposits[index]) {
      setFieldValue(`checkDeposits.${index}`, initialValues.checkDeposits[index]);
    } else {
      remove(index);
    }
  };

  return (
    <StyledTable columnCount={columns.length}>
      <StyledTableHeader>
        <StyledTableRow>
          <div></div>

          {columns.map((t) => (
            <div className={'items-end p-4'} key={t}>
              {t}
            </div>
          ))}
          <div></div>
        </StyledTableRow>
      </StyledTableHeader>
      <StyledTableContent>
        {checkDeposits.map((item, i) => (
          <IncomingDepositRow
            fieldName={'checkDeposits'}
            index={i}
            remove={() => remove(i)}
            onCancelEdit={() => onCancelEdit(i)}
            onDelete={() => onDelete(item.id)}
            newDeposit={!item.createdAt}
            depositData={{ ...checkDeposits[i], depositType: 'Check' }}
            key={item.id ?? i}
          >
            &nbsp;
          </IncomingDepositRow>
        ))}
      </StyledTableContent>
    </StyledTable>
  );
};
